export const iotdevicetext = {
    id: "Identifiant",
    name: "Nom",
    description: "Description",
    group: "Site",
    definition: "Type",
    category: "Catégorie",
    deveui: "DEV EUI",
    eosprotocol: "Type de connexion",
    linkmargin: "Signal",
    battery: "Etat de la batterie",
    lastseen: "Dernière connexion",
    updategroupchoice : "Mise à jour du périmètre",
    concatdl: "Concaténer les downloads",
    lorawanclass: "Classe LoRaWAN",
}